import React from "react";
import ReactDOM from "react-dom";
import { AiFillCloseCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
import CreateProductModal from "./CreateProductModal";
const AddInventoryModal = ({ open }) => {
  const dispatch = useDispatch();
  if (!open) return null;
  return ReactDOM.createPortal(
    <div className="modal-container">
      <div className="modal-inventory">
        <h3 className="header_title">Inventory</h3>
        <button
          className="add_btn"
          onClick={() =>
            dispatch({ type: "CLOSE_ADD_PRODUCT_MODAL", payload: false })
          }
        >
          <AiFillCloseCircle />
        </button>
        <CreateProductModal />
      </div>
    </div>,
    document.getElementById("modal")
  );
};

export default AddInventoryModal;
